//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
import {requestByPost} from '@/util/request';
import {API} from '@/util/api';
import { areaData } from "../../util/areaDataNew";
import Multiselect from "vue-multiselect";
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
export default {
 name: 'grid',
 data(){
    return {
      value:'',
      active:1,
      activeD:1,
      gridList:[],//网格信息list
      pageSizeSel: 12, //首页各项默认显示几条
      selObj: {},
      canSelDemand: true,//是否还能点击加载更多  true可以，false已经全显示完了
      loadDemandName: "加载更多",//底部加载更多按钮名称
      searchStr: null,
      provinceData: areaData, // 省下拉列表
      province: null, // 省
      city: null, // 市
      area: null, // 区
      cityData: [], // 市下拉列表
      areaData: [], // 区下拉列表
      checkProvinceId: null, // 选中的省id
      checkCityId: null, // 选中的 市id
      checkAreaId: null, // 选中的 区id
    }
  },
 components:{
    Header,
    Footer, 
    Multiselect
 },

 
  mounted(){
    document.title = "协会列表"
        $$(document).scroll(function(){
      var y = $$(document).scrollTop()
      console.log()
      if(y >= 100){
          $(".newindextop").addClass("newindextop1").css({"top":0})
      }else{
         $(".newindextop").removeClass("newindextop1").css({"top":0})
      }
    })
  },
  created(){
    let that = this;
    this.$store.commit('home/setCommonSocietyId', null);//协会id
    this.$store.commit('home/setCommonSocietyName', null);//协会名称
    this.$store.commit('home/setSocietyLogoUrl', null);//协会logo
    window.localStorage.setItem('societyId','')
    window.localStorage.setItem('societyName','')
    // that.xmpcCpalSelObj = {"page":{"pageNum":0,"pageSize": that.pageSizeSel},"searchStr": that.searchStr};
    // that.companySelObj = {"page":{"pageNum":0,"pageSize": that.pageSizeSel},"searchStr": that.searchStr};
     
    // this.$store.commit('home/setMenuStyle', 1);//为了显示灰色头部背景   2025数字云平台位置
    // this.$store.commit('home/setMenuActive', 3);
    // that.selType = (that.$route.query.selType != null && this.$route.query.selType != "" ) ? this.$route.query.selType : 1;
    // if(that.selType == 2){
    //   that.$store.commit('home/setMenuActive', 1);////
    // }



    // this.$store.commit('home/setMenuStyle', 4);//为了显示灰色头部背景   2025数字云平台位置
   that.$store.commit('home/setMenuActive', 3);//协会菜单
   that.fnLoadGirdList(2);

    
  },
  updated(){
    //每个16:9的图片加载完重新算高度
    $$(".autoHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*9/16);
    });
    //每个16:7.52的图片(企业封面)加载完重新算高度
    $$(".autoCompanyImgHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*7.52/16);
    });
    
  },
methods:{
    //选择省份后处理城市
      fnHandleCity() {
        if(this.province != null){
          //选择的省份id
          this.checkProvinceId = this.province.id;
          this.cityData = this.province.items;
        }else{
          //选择的省份id
          this.checkProvinceId = null;
          this.cityData = [];
        }
        this.checkCityId = null; // 选中的 市id
        this.checkAreaId = null; // 选中的 区id
        this.areaData = [];
        this.city = null;
        this.area = null;

        this.fnLoadGirdList(2);
    },
     // 选择城市后处理地区
    fnHandleArea() {
      if(this.city != null){
         //选择的市id
        this.checkCityId = this.city.id;
        this.areaData = this.city.items;
      }else{
        //选择的市id
        this.checkCityId = null;
        this.areaData = [];
      }
      this.checkAreaId = null; // 选中的 区id
      this.area = null;
      this.fnLoadGirdList(2);
    },
    // 选择区后，处理逻辑
    fnHandleLast() {
      if(this.area != null){
        //选择的区id
        this.checkAreaId = this.area.id;
      }else{
        //选择的区id
        this.checkAreaId = null;
      }
      this.fnLoadGirdList(2);
    },
    addC(params){
        this.active = params
    },
    addD(params){
        this.activeD = params
    },
    /* 加载网格信息list */
    fnLoadGirdList(inType){
      let that = this
      if (inType == 2) {
        that.canSelDemand = true
      }
      if (that.canSelDemand) {
        if (inType == 1) {
          let page = that.selObj.page;
          page.pageNum = Number(page.pageNum)+1;
          that.selObj.page = page;
        }else{
          that.userDemandList = [];
          let page = new Object();
          page.pageNum = 0;
          page.pageSize = that.pageSizeSel;
          that.selObj.page = page;
          that.selObj.isSelGird = 1;
          that.selObj.searchStr = that.searchStr
          that.selObj.provinceCode = that.checkProvinceId;
          if(that.checkProvinceId != null && that.checkProvinceId != "" && that.checkProvinceId != "-1"){
            that.selObj.cityCode = that.checkCityId;
            if(that.checkCityId != null && that.checkCityId != "" && that.checkCityId != "-1"){
              that.selObj.areaCode = that.checkAreaId;
            }else{
              that.selObj.areaCode = null;
            }
          }else{
             that.selObj.cityCode = null;
              that.selObj.areaCode = null;
          }
        }
        requestByPost(API.selGridPageForHome,JSON.stringify(that.selObj)).then((res)=>{
          if(res.data != undefined && res.data.obj != undefined && res.data.obj != null && res.data.otherList != null &&  res.data.otherList.length != 0){
            that.loadDemandName = "加载更多";
            that.canSelDemand = true;
            let gridList = res.data.otherList;
            if(inType == 1){//分页查询
              gridList.forEach((item, index) => {
                that.gridList.push(item);
                if(that.gridList.length == res.data.obj.page.total){
                  that.canSelDemand = false;
                  that.loadDemandName = "~没有更多了~";
                }
              })
            }else{
              that.gridList = gridList;
              if(that.gridList.length == res.data.obj.page.total){
                  that.canSelDemand = false;
                  that.loadDemandName = "~没有更多了~";
                }
            }
          }else{
            if(inType == 2){//
              that.gridList = [];
            }
            that.canSelDemand = false;
            that.loadDemandName = "~没有更多了~";
          }
        })
      }
    },
    fnShowSocietyIndex(societyId,societyName,logoImgUrl,e){
      this.fnStopBub(e);
      // this.$store.commit('home/setSocietyLogoUrl', logoImgUrl);//协会logo
      // this.$store.commit('home/setCommonSocietyId', societyId);//协会菜单
      // this.$store.commit('home/setCommonSocietyName', societyName);//协会菜单
      window.localStorage.setItem('societyId',societyId);
      window.localStorage.setItem('societyName',societyName);
      window.localStorage.setItem('logoImgUrl',logoImgUrl);
      this.$router.push({path: '/societyIndex', query: {societyId:societyId}});
    },
     //分辨率控制协会名称字体大小
    fnGetJgFontSizeNum(companyName){
       // 分辨率控制字体大小
      if(window.screen.width <= 1367 && companyName.length > 17){
        return  "font-size: 18px;margin-bottom: 11px;";
      } else if (window.screen.width <= 1601 && companyName.length > 17) {
        return  "font-size: 18px;margin-bottom: 11px;";
      }
      return "font-size: 22px;";
    },
    //跳转到特定导航页面
    fnGotoDhPage(param){
      this.$store.dispatch('home/fnGoToPage', param).then(res=>{
        this.showMenuType = 0
        if(res != null && res != "" && res.indexOf("companyInfoList") < 0){
          this.$router.push({ path: res })
        }else if(res != null  && res != ""  &&  res.indexOf("companyInfoList") > -1){
           this.fnGotoSearchPage(2);
        }else{
          Toast("敬请期待")
        }
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/grid/grid.vue